<form *ngIf='team' [formGroup]="teamSubscriptionForm" class="d-flex flex-column custom-modal-content">
    <div class='my-5'>
            <app-input-field [parentForm]='teamSubscriptionForm' [inputJson]='teamIdFieldObject'>
            </app-input-field>
    </div>
</form>